import { render, staticRenderFns } from "./ListagemPenalidadesPedidoBotoesAcoes.vue?vue&type=template&id=0948628b&scoped=true"
import script from "./ListagemPenalidadesPedidoBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ListagemPenalidadesPedidoBotoesAcoes.vue?vue&type=script&lang=js"
import style0 from "./ListagemPenalidadesPedidoBotoesAcoes.vue?vue&type=style&index=0&id=0948628b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0948628b",
  null
  
)

export default component.exports